export const FINALISTS = [
    // Locke Burger - ROTY, Ire
    2,
    // Brorritos ROTY, Lon
    55,
    // Tofu Vegan Health Focused ROTY, Lon
    // 61,
    // What the pitta, Sustainable ROTY, Lon
    // 56,
    // Eat Lebo - Health Foc ROTY, Lon
    // 57,
    // LYFBAR - ROTY, Mid
    41,
    // Chainak - Sust roty, mid
    // 40,
    // Taste From India - Comm Impact roty, mid
    // 42,
    // Doreen's - Female Chef mid
    // 43,
    // Brack Burger - ROTY / Comm Impact, ne
    70,
    // PiCNIC - roty + health foc nw
    73,
    // Seed, roty ni
    82,
    // Big manny, roty, scot
    13,
    // Nattys Jerk, roty se
    48,
    // Need street food Comm impact roty se
    // 49,
    // Sandwich Sandwich roty sw
    30,
    // Taylors Bagels, fem chef roty sw
    // 35,
    // Koocha fem chef sw
    // 34,
    // Haystack cafe roty wales
    23,
    // ANSH CYMRU - sust roty wales
    // 20,
];

export const SHORTLIST = [
    {
        name: 'Griolladh',
        area: 'i',
        image: 'griolladh.jpg',
    },
    {
        name: 'Locke Burger',
        area: 'i',
        image: 'lockeburger.jpg',
    },
    {
        name: 'The SpitJack (Bedford Row)',
        area: 'i',
        image: 'thespitjack.jpg',
    },
    {
        name: 'Sambros',
        area: 'i',
        image: 'sambros.jpg',
    },
    {
        name: 'Chaat&Co.',
        area: 'i',
        image: 'chaatandcochicken.jpg',
    },
    {
        name: 'Kale+Coco',
        area: 'i',
        image: 'kaleaddcoco.jpg',
    },
    {
        name: 'Dublin Pizza Co.',
        area: 'i',
        image: 'dublinpizzaco.jpg',
    },
    {
        name: 'Handsome Burger',
        area: 'i',
        image: 'handsomeburger.jpg',
    },
    {
        name: 'SabaToGo',
        area: 'i',
        image: 'sabatogo.jpg',
    },
    /* {
        name: 'Restaurant Name',
        area: 'i',
        image: '',
    }, */
    {
        name: 'Razzo Pizza Napoletana',
        area: 's',
        image: 'razzopizzanapoletana.jpg',
    },
    {
        name: 'Jimmy\'s Express 有口福',
        area: 's',
        image: 'jimmysexpress.jpg',
    },
    {
        name: 'Mother India',
        area: 's',
        image: 'motherindia.jpg',
    },
    {
        name: 'Big Manny\'s',
        area: 's',
        image: 'bigmannys.jpg',
    },
    {
        name: 'Yippon',
        area: 's',
        image: 'yippon.jpg',
    },
    {
        name: 'Damasqino',
        area: 's',
        image: 'damasqino.jpg',
    },
    {
        name: 'Charcoals',
        area: 's',
        image: 'charcoalsglasgow.jpg',
    },
    {
        name: 'Bucks Bar',
        area: 's',
        image: 'bucksbar.jpg',
    },
    {
        name: 'Salt & Chilli Oriental',
        area: 's',
        image: 'saltandchillioriental.jpg',
    },
/*     {
        name: 'Restaurant Name',
        area: 's',
        image: '',
    }, */
    {
        name: 'eat the bird (Cardiff)',
        area: 'w',
        image: 'eatthebird.jpg',
    },
    {
        name: 'ANSH CYMRU',
        area: 'w',
        image: 'anshcymru.jpg',
    },
    {
        name: 'Poutine Box',
        area: 'w',
        image: 'poutinebox.jpg',
    },
    {
        name: 'Baba\'s',
        area: 'w',
        image: 'babas.jpg',
    },
    {
        name: 'Haystack Cafe',
        area: 'w',
        image: 'haystackcafe.jpg',
    },
    {
        name: 'Top Deck',
        area: 'w',
        image: 'topdeck.jpg',
    },
    {
        name: 'The Pizza Boyz',
        area: 'w',
        image: 'thepizzaboyz.jpg',
    },
    {
        name: 'Smokin Griddle (Swansea)',
        area: 'w',
        image: 'smokingriddle.jpg',
    },
    {
        name: 'Bashed UK',
        area: 'w',
        image: 'bashed.jpg',
    },
    /* {
        name: 'Restaurant Name',
        area: 'w',
        image: '',
    }, */
    {
        name: 'Chilli Daddy',
        area: 'sw',
        image: 'chillidaddy.jpg',
    },
    {
        name: 'The Arjee Bhajee',
        area: 'sw',
        image: 'arjeesouthwest.jpg',
    },
    {
        name: 'Sandwich Sandwich',
        area: 'sw',
        image: 'sandwichsandwich.jpg',
    },
    {
        name: 'Streatwok',
        area: 'sw',
        image: 'streatwok.jpg',
    },
    {
        name: 'Low and Slow Barbecue',
        area: 'sw',
        image: 'lowandslowbarbecue.jpg',
    },
    {
        name: 'Daily Noodles',
        area: 'sw',
        image: 'dailynoodles.jpg',
    },
    {
        name: 'Koocha',
        area: 'sw',
        image: 'koocha.jpg',
    },
    {
        name: 'Taylors Bagels & Coffee',
        area: 'sw',
        image: 'taylorsbagelandcoffee.jpg',
    },
    {
        name: 'Cathay Rendezvous 满庭欢',
        area: 'sw',
        image: 'cathayrendezvous.jpg',
    },
/*     {
        name: 'Restaurant Name',
        area: 'sw',
        image: '',
    }, */
    {
        name: 'Seoul Bowl',
        area: 'mid',
        image: 'seoulbowl.jpg',
    },
    {
        name: 'Doorstep Desserts',
        area: 'mid',
        image: 'doorstepdesserts.jpg',
    },
    {
        name: 'Grosvenor Fish Bar',
        area: 'mid',
        image: 'grosvenorfishbar.jpg',
    },
    {
        name: 'Chainak',
        area: 'mid',
        image: 'chainak.jpg',
    },
    {
        name: 'LYFBAR',
        area: 'mid',
        image: 'lyfbar.jpg',
    },
    {
        name: 'Taste From India',
        area: 'mid',
        image: 'tastefromindia.jpg',
    },
    {
        name: 'Doreen\'s Kitchen',
        area: 'mid',
        image: 'doreenskitchen.jpg',
    },
    {
        name: 'Asha\'s',
        area: 'mid',
        image: 'ashas.jpg',
    },
    {
        name: 'TZATZIKI',
        area: 'mid',
        image: 'tzatziki.jpg',
    },
    /* {
        name: 'Restaurant Name',
        area: 'mid',
        image: '',
    }, */
    {
        name: 'Baffi',
        area: 'se',
        image: 'baffipizzeria.jpg',
    },
    {
        name: 'Mango Thai Tapas',
        area: 'se',
        image: 'mangothaitapas.jpg',
    },
    {
        name: 'Natty\'s Jerk Kitchen',
        area: 'se',
        image: 'nattysjerkkitchen.jpg',
    },
    {
        name: 'Need Street Food',
        area: 'se',
        image: 'needstreetfood.jpg',
    },
    {
        name: 'Drgnfly',
        area: 'se',
        image: 'drgnfly.jpg',
    },
    {
        name: 'LostBoysLand',
        area: 'se',
        image: 'lostboysland.jpg',
    },
    {
        name: 'Carlito Burrito',
        area: 'se',
        image: 'carlitoburrito.jpg',
    },
    {
        name: 'Social Board',
        area: 'se',
        image: 'socialboard.jpg',
    },
    {
        name: 'Half Man! Half Burger!',
        area: 'se',
        image: 'halfmanhalfburger.jpg',
    },
/*     {
        name: 'Restaurant Name',
        area: 'se',
        image: '',
    }, */
    {
        name: 'Brorritos',
        area: 'l',
        image: 'brorritos.jpg',
    },
    {
        name: 'What the Pitta',
        area: 'l',
        image: 'whatthepitta.jpg',
    },
    {
        name: 'Eat Lebö',
        area: 'l',
        image: 'eatlebo.jpg',
    },
    {
        name: 'Skewd Kitchen',
        area: 'l',
        image: 'skewdkitchen.jpg',
    },
    {
        name: 'It\'s All Greek To Me',
        area: 'l',
        image: 'itsallgreektome.jpg',
    },
    {
        name: 'Roti King',
        area: 'l',
        image: 'rotiking.jpg',
    },
    {
        name: 'Tofu Vegan',
        area: 'l',
        image: 'tofuvegan.jpg',
    },
    {
        name: 'Gunpowder',
        area: 'l',
        image: 'gunpowder.jpg',
    },
    {
        name: 'Halo Burger',
        area: 'l',
        image: 'haloburger.jpg',
    },
/*     {
        name: 'Restaurant Name',
        area: 'l',
        image: '',
    }, */
    {
        name: 'Sibu',
        area: 'ne',
        image: 'sibu.jpg',
    },
    {
        name: 'Street Food Chef',
        area: 'ne',
        image: 'thestreetfoodchef.jpg',
    },
    {
        name: 'Home Chinese',
        area: 'ne',
        image: 'homechinese.jpg',
    },
    {
        name: 'Farsley Fire & Smoke BBQ',
        area: 'ne',
        image: 'farsleyfireandsmokebbq.jpg',
    },
    {
        name: 'Scream for Pizza',
        area: 'ne',
        image: 'screamforpizza.jpg',
    },
    {
        name: 'Acropolis',
        area: 'ne',
        image: 'acropolisgyros.jpg',
    },
    {
        name: 'Brack Burger',
        area: 'ne',
        image: 'brackburger.jpg',
    },
    {
        name: 'King Baby bagels',
        area: 'ne',
        image: 'kingbabybagels.jpg',
    },
    {
        name: 'Sim\'s Kitchen',
        area: 'ne',
        image: 'simskitchen.jpg',
    },
/*     {
        name: 'Restaurant Name',
        area: 'ne',
        image: '',
    }, */
    {
        name: 'PiCNIC',
        area: 'nw',
        image: 'picnic.jpg',
    },
    {
        name: 'Big Lola\'s',
        area: 'nw',
        image: 'biglolas.jpg',
    },
    {
        name: 'Caribou Poutine',
        area: 'nw',
        image: 'cariboupoutine.jpg',
    },
    {
        name: 'Aros Kitchen',
        area: 'nw',
        image: 'aroskitchen.jpg',
    },
    {
        name: 'Nashville Cluck',
        area: 'nw',
        image: 'nashvillecluck.jpg',
    },
    {
        name: 'Burger & Co',
        area: 'nw',
        image: 'burgerandco.jpg',
    },
    {
        name: 'Mughli Charcoal Pit',
        area: 'nw',
        image: 'mughlicharcoalpit.jpg',
    },
    {
        name: 'Salt & Pepper',
        area: 'nw',
        image: 'saltandpepper.jpg',
    },
    {
        name: 'Three brothers',
        area: 'nw',
        image: 'threebrothers.jpg',
    },

    {
        name: 'Seed',
        area: 'ni',
        image: 'seed.jpg',
    },
    {
        name: 'Eatao Asian Fusion',
        area: 'ni',
        image: 'eataoasianfusion.jpg',
    },
    {
        name: 'Pizza Guyz',
        area: 'ni',
        image: 'pizzaguyzfood.jpeg',
    },
    {
        name: 'Taste of India',
        area: 'ni',
        image: 'tasteofindia.jpg',
    },
    {
        name: 'Oggies',
        area: 'ni',
        image: 'oggies.jpg',
    },
    {
        name: 'Street Dogs Street Kitchen',
        area: 'ni',
        image: 'streetdogsstreetkitchen.jpg',
    },
    {
        name: 'Sunnys',
        area: 'ni',
        image: 'sunnysfood.jpeg',
    },
    {
        name: 'Nu Delhi',
        area: 'ni',
        image: 'nudehli.jpg',
    },
    {
        name: 'Yosi Healthy Street Food',
        area: 'ni',
        image: 'yosihealthystreetfood.jpg',
    },
]